module.exports = __webpack_public_path__ + "static/img/er.9a3a7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/er.png
// module id = EpjL
// module chunks = 1 2 3 4 5 7 8 9 13 14 24 25 26